/* lua.js generated code 0.3.0 */

require("clover/data/UserManager")
var ItemType = require("clover/data/ItemType")
var Event = require("cocos/framework/components/event")
UserProp = xClass("UserProp", Event)
UserPropEvent = table(
    [1, "AddProp", "USERPROPEVENT.ADDPROP"],
    [1, "ConsumeProp", "USERPROPEVENT.CONSUMEPROP"],
    [1, "PropNumberChange", "USERPROPEVENT.PROPNUMBERCHANGE"]
)
var instance = null
UserProp.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserProp.new()
    }
    return instance
}
UserProp.prototype.ctor = function () {
    var self = this
    self.bind(self)
    self.propEffect = require("clover/logic/userProp/UserPropEffect")
    self.userPropAddProp = require("clover/logic/userProp/UserPropAddProp")
    self.lockedPropCount = table()
    self.removeAllTempProps()
}
UserProp.prototype.addPropList = function (rewardList) {
    let self = this
    let $limit7 = $len(rewardList)
    for (let i = 1; i <= $limit7; i += 1) {
        self.addProp(rewardList[i].itemId, rewardList[i].num)
    }
}
UserProp.prototype.addProp = function (propId, num, targetId, param, sceneName) {
    var self = this
    self.userPropAddProp(propId, num, targetId, param, sceneName)
    self.dispatchEvent(table(
        [1, "name", UserPropEvent.AddProp],
        [1, "propId", propId],
        [1, "num", num],
        [1, "targetId", targetId],
        [1, "param", param]
    ))
    self.dispatchEvent(table(
        [1, "name", UserPropEvent.PropNumberChange],
        [1, "propId", propId],
        [1, "num", self.getPropNumber(propId)[0]]
    ))
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
// 奖励获得物品
UserProp.prototype.rewardProp = function (propId, num, targetId, param, sceneName, dcData) {
    var self = this;
    self.addProp(propId, num, targetId, param, sceneName)
    self.dcRewardProp(propId, num, sceneName, dcData);
}
// 获得奖励道具打点，不同步道具数量   
UserProp.prototype.dcRewardProp = function(propId, num, sceneName, dcData){
    var coin1 = 0
    if (tonumber(propId) === ItemType.COIN) {
        coin1 = UserManager.getInstance().getUserRef().getCoin() || 0
        coin1 -= num
    } else if (tonumber(propId) === ItemType.GOLD) {
        coin1 = UserManager.getInstance().getUserRef().getCash() || 0
        coin1 -= num
    } else {
        coin1 = 0
    }
    // 记录使获得前道具数量
    let item1 = getPropNumber(propId);
    if (!dcData) {
        dcData = table()
    }
    dcData.trade_id = "0"
    dcData.item_worth = ItemWorth.OTHER
    dcData.worth_num = "0"
    dcData.item1 = item1;
    dcData.item2 = getPropNumber(propId);
    DCAssist.dc4GetThings(propId, num, sceneName, dcData)
    var coin2 = 0
    var currency = ""
    if (tonumber(propId) === ItemType.COIN) {
        coin2 = UserManager.getInstance().getUserRef().getCoin() || 0
        currency = ItemWorth.GAME_COINS
    } else if (tonumber(propId) === ItemType.GOLD) {
        coin2 = UserManager.getInstance().getUserRef().getCash() || 0
        currency = ItemWorth.HAPPY_COINS
    } else {
        coin2 = 0
    }
    dcData.currency = currency || ""
    dcData.coin1 = coin1 || 0
    dcData.coin2 = coin2 || 0
    DCAssist.dc4GetCurrency(propId, num, sceneName, dcData)
}
UserProp.prototype.getPropNumber = function (propId) {
    var self = this
    if (UserPropData.isTimeProp(propId)) {
        // WARN: maybe multi result
        return [UserManager.getInstance().getUserTimePropNumber(propId), UserManager.getInstance().getFirstTimePropExpireTime(propId)]
    } else if (UserPropData.isAdProp(propId)){
        let AdPropLogic =  require("../../gamePlay/BoardLogic/AdPropLogic");
        if (!AdPropLogic.hasRfreshProp){
            // 自由刷新道具时是不会显示道具广告的
            return AdPropLogic.isShowInStage(propId)? [1]: [0];
        }else{
            return [0];
        }
    } else {
        // WARN: maybe multi result
        return [UserManager.getInstance().getUserPropNumber(propId)]
    }
}

//传入基础前置道具id，判断是否有对应的无限道具
UserProp.prototype.getInfinitePreProp = function (propId) {
    var self = this
    if (!InfinitePrePropsMap[propId] || !UserManager.getInstance().getUserTimePropNumber(InfinitePrePropsMap[propId])){
        return null
    }

    let now = Localhost.time()
    let expireTime = UserManager.getInstance().getFirstTimePropExpireTime(InfinitePrePropsMap[propId])
    if (now > expireTime){
         return null
    }
    // if (userShow && userShow[item] && userShow[item].id && userShow[item].use == 1 && (userShow[item].expireTime <= 0 ||  now < userShow[item].expireTime)){
    //     return userShow[item].id
    // } 
    return [InfinitePrePropsMap[propId], expireTime]
}
//传入基础前置道具id，判断是否有对应的限时限次道具
UserProp.prototype.getLitmitedPreProp = function (propId) {
    var self = this
    if (!LimitedPrePropsMap[propId] || !UserManager.getInstance().getUserTimePropNumber(LimitedPrePropsMap[propId])){
        return [null, null];
    }

    let now = Localhost.time()
    let expireTime = UserManager.getInstance().getFirstTimePropExpireTime(LimitedPrePropsMap[propId])
    if (now > expireTime){
         return [null, null];
    }
    return [LimitedPrePropsMap[propId], expireTime]
}
UserProp.prototype.getPropNumberByTime = function (propId, time) {
    var self = this
    time = time || Localhost.time()
    if (UserPropData.isTimeProp(propId)) {
        // WARN: maybe multi result
        return [UserManager.getInstance().getUserTimePropNumberAfterTime(propId, time), UserManager.getInstance().getFirstTimePropExpireTimeAfterTime(propId, time)]
    } else {
        // WARN: maybe multi result
        return [UserManager.getInstance().getUserPropNumber(propId)]
    }
}
UserProp.prototype.getAvaliablePropNumber = function (propId) {
    var self = this
    if (UserPropData.isTimeProp(propId)) {
        // 这里其实并不严谨 因为使用的时间是不相同的 不过除开遇到这种状况的可能性 减少让用户使用的数量也会减少出错的可能
        // WARN: maybe multi result
        return Math.max(UserManager.getInstance().getUserTimePropNumber(propId) - (self.lockedPropCount[propId] || 0), 0)
    } else if(UserPropData.isAdProp(propId)){
        let AdPropLogic =  require("../../gamePlay/BoardLogic/AdPropLogic");
        return Math.max((AdPropLogic.isShowInStage(propId)? 1: 0) - (self.lockedPropCount[propId] || 0), 0)
    } else {
        // WARN: maybe multi result
        return Math.max(UserManager.getInstance().getUserPropNumber(propId) - (self.lockedPropCount[propId] || 0), 0)
    }
}
UserProp.prototype.getAvaliablePropNumberByTime = function (propId, time) {
    var self = this
    time = time || Localhost.time()
    if (UserPropData.isTimeProp(propId)) {
        // 这里其实并不严谨 因为使用的时间是不相同的 不过除开遇到这种状况的可能性 减少让用户使用的数量也会减少出错的可能
        // WARN: maybe multi result
        return Math.max(UserManager.getInstance().getUserTimePropNumberAfterTime(PropId, time) - (self.lockedPropCount[propId] || 0), 0)
    } else {
        // WARN: maybe multi result
        return Math.max(UserManager.getInstance().getUserPropNumber(propId) - (self.lockedPropCount[propId] || 0), 0)
    }
}
UserProp.prototype.getPropExpireTime = function (propId) {
    var self = this
    // WARN: maybe multi result
    return UserManager.getInstance().getFirstTimePropExpireTime(propId)
}
UserProp.prototype.canUseProp = function (props, levelId, params) {
    if (UserManager.getInstance().canGmPropUse){   
		return [true]
    }
    var self = this
    var itemList = self.mergePropList(props)
    for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        // if (UserPropData.isAdProp(v.itemId)) {
        //     continue;
        // }
        var propMeta = MetaManager.getInstance().getPropMeta(v.itemId)
        if (!propMeta) {
            // 使用的道具列表中有当前版本不支持的道具
            // 这里前后端不同 后端报错是USE_PROP_RANGE_ERROR
            return [false, ZooErrorCode.VERSION_UNSUPPORT]
        }
        var unlockLevelId = (propMeta || table()).unlock || 0
        if (UserPropData.isBagPreLevelProp(v.itemId) &&  UserManager.getInstance().getGroupByKey(MetaManager.prePropsGuideConfig.ab_test_name) == "b"){
            unlockLevelId = MetaManager.prePropsGuideConfig.unlock_lv
        }
        if (UserManager.getInstance().getUserRef().getTopLevelId() < unlockLevelId) {
            return [false, ZooErrorCode.USE_PROP_LEVEL_ERROR]
        }
        if (self.getAvaliablePropNumber(v.itemId) < v.num) {
            return [false, ZooErrorCode.PROP_NOT_ENOUGH]
        }
    }
    for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        if (type(levelId) === "number" && levelId > 0) {
            var level = UserLevel.getInstance().getCurrentLevel()
            if (level) {
                var [success, errCode] = level.canUseProp(v.itemId, v.num)
                if (!success) {
                    return [success, errCode]
                }
            } else {
                return [false, ZooErrorCode.USE_PROP_RANGE_ERROR]
            }
        }
    }
    return [true]
}

//energyParam 开始自动使用精力瓶用
UserProp.prototype.useProp = function (props, levelId, param, successCallback, failCallback, cancelCallback, sceneName, isOnline, energyParam) {
    var self = this
    isOnline = isOnline == null ? true : isOnline
    //临时道具走离线
    if (UserPropData.isTempProp(props[1])) {
        isOnline = false
    }
    // 引导用无限道具直接返回成功
    if (UserPropData.isInfiniteProp(props[1])) {
        let num = 0
        let prop = props[1]
        let level = UserLevel.getInstance().getCurrentLevel()
        if (level) {
            level.useInfiProp(prop)
            num = level.getInfiPropUseCount(prop)
        }
        DCAssist.dc4InfiProp(levelId, prop, num)
        if (successCallback) {
            successCallback()
        }
        return 
    }
    let AdPropLogic = require("../../gamePlay/BoardLogic/AdPropLogic")
    function onSuccess(event) {
        UserManager.getInstance().updateLevelConsumeLocal(levelId, props)

        AdPropLogic.useProp(props && props[1]);
        let itemCountBefore = {}
        var itemList = self.mergePropList(props)
        for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
            self.lockedPropCount[v.itemId] = Math.max((self.lockedPropCount[v.itemId] || 0) - v.num, 0)
            itemCountBefore[v.itemId] = getPropNumber(v.itemId);
        }
        self.consumeProp(itemList, levelId, param)
        for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
            self.propEffect(v.itemId, v.num, levelId, param)
        }
        if (type(levelId) === "number" && levelId > 0) {
            var itemList = self.mergePropList(props)
            var level = UserLevel.getInstance().getCurrentLevel()
            if (level) {
                for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
                    level.useProp(v.itemId, v.num)
                }
            }
        }
        if (successCallback) {
            successCallback()
        }
        DCAssist.dc4UseThings(itemList, sceneName, energyParam, itemCountBefore);
    }
    function onFail(event) {
        var itemList = self.mergePropList(props)
        for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
            self.lockedPropCount[v.itemId] = Math.max((self.lockedPropCount[v.itemId] || 0) - v.num, 0)
        }
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        if (cancelCallback) {
            cancelCallback()
        }
    }
    var [success, errCode] = self.canUseProp(props, levelId, param)
    if (!success) {
        onFail(table([1, "data", errCode]))
        return 
    }
    // 请求前 无论结果如何 先独占此资源直到请求结束
    for (var i = 1, v = props[1]; v; i++, v = props[i]) {
        self.lockedPropCount[v] = (self.lockedPropCount[v] || 0) + 1
    }
    var http
    if (isOnline) {
        http = UsePropsOnlineHttp.new(true)
    } else {
        http = UsePropsOfflineHttp.new(false)
    }
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    if (UserPropData.isTimeProp(props[1])) {
        // local body = {
        // 	type = 1,
        // 	levelId = levelId,
        // 	gameMode = gameMode,
        // 	param = param,
        // 	itemList = props,
        // 	requestTime = Localhost:time()
        // }
        // http:load(body)
        http.load(1, levelId, param, props)
    } else if (UserPropData.isTempProp(props[1])) {
        // local body = {
        // 	type = 3,
        // 	levelId = levelId,
        // 	gameMode = gameMode,
        // 	param = param,
        // 	itemList = props,
        // 	requestTime = Localhost:time()
        // }
        // http:load(body)
        http.load(3, levelId, param, props)
    } else if (UserPropData.isAdProp(props[1])) {
        AdPropLogic.playAd(props[1], function(errCode){
            if (errCode == null) {
                http.load(4, levelId, param, props)
            } else {
                onFail({data: errCode});
            }
        })
    } else {
        // local body = {
        // 	type = 2,
        // 	levelId = levelId,
        // 	gameMode = gameMode,
        // 	param = param,
        // 	itemList = props,
        // 	requestTime = Localhost:time()
        // }
        // http:load(body)
        http.load(2, levelId, param, props)
    }
}
UserProp.prototype.consumeProp = function (propList, levelId, params) {
    var self = this
    for (var i = 1, v = propList[1]; v; i++, v = propList[i]) {
        if (UserPropData.isInfinitePreProp(v.itemId)){
            
        }else if (UserPropData.isTimeProp(v.itemId)) {
            UserManager.getInstance().useTimeProp(v.itemId, v.num)
        } else {
            UserManager.getInstance().addUserPropNumber(v.itemId, -v.num)
        }
        self.dispatchEvent(table(
            [1, "name", UserPropEvent.ConsumeProp],
            [1, "propId", v.itemId],
            [1, "num", v.num],
            [1, "param", params]
        ))
        self.dispatchEvent(table(
            [1, "name", UserPropEvent.PropNumberChange],
            [1, "propId", v.itemId],
            [1, "num", self.getPropNumber(v.itemId)[0]]
        ))
    }
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserProp.prototype.mergePropList = function (props) {
    var self = this
    var tmp = table()
    for (var i = 1, v = props[1]; v; i++, v = props[i]) {
        tmp[v] = (tmp[v] || 0) + 1
    }
    var ret = table()
    for (var k in tmp) {
        var v = tmp[k]
        if(!v){
            continue
        }
        k = tonumber(k)
        table.insert(ret, table([1, "itemId", k], [1, "num", v]))
    }
    return ret
}
UserProp.prototype.removeAllTempProps = function () {
    let self = this
    let userMgr = UserManager.getInstance()
    let $st63 = MetaManager.getInstance().getPropMetaRef() || table()
    for (let k in $st63) {
        let v = $st63[k]
        if ($null(v)) continue
        if (UserPropData.isTempProp(v.id) || UserPropData.isInfiniteProp(v.id)) {
            if (userMgr.getUserProp(v.id)) {
                userMgr.setUserPropNumber(v.id, 0)
            }
        }
    }
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}

function getPropNumber(propId) {
    if (UserPropData.isTimeProp(propId)) {
        return UserManager.getInstance().getUserTimePropNumber(propId);
    } else {
        return UserManager.getInstance().getUserPropNumber(propId);
    }
}
module.exports = UserProp
